import Account from 'lib/auth/Account';
import Env from 'lib/env/Env';
import type { EnterpriseListFilter } from './enterprise.api';

/**
 * Enterprise routes are mounted at `/web/v1/enterprise`, not under `/workspaces/:schema`
 * and not at legacy `/v1/*` (that prefix 404s on the core app).
 */
export function resolveWebV1ApiRoot(): string {
  const apiUrl = Env.apiURL.replace(/\/$/, '');
  if (apiUrl.endsWith('/web/v1')) {
    return apiUrl;
  }
  if (apiUrl.endsWith('/v1')) {
    return `${apiUrl.slice(0, -'/v1'.length)}/web/v1`;
  }
  return `${apiUrl}/web/v1`;
}

/** Enterprise routes are mounted at `/web/v1/enterprise`, not under `/workspaces/:schema`. */
export function enterpriseApiUrl(path: string): string {
  const normalized = path.startsWith('/') ? path : `/${path}`;
  return `${resolveWebV1ApiRoot()}/enterprise${normalized}`;
}

/**
 * Backend list endpoints accept `archived` query param (boolean).
 * Omitted / false → active items only; true → archived items only.
 */
export function enterpriseListFilterToArchivedParam(
  filter: EnterpriseListFilter = 'active'
): boolean {
  return filter === 'archived';
}

/**
 * Backend `orgWorkspaceId` is the auth workspace CUID.
 * App routing uses `organizationId` = workspace db_schema (`app_id`).
 */
export function resolveOrgWorkspaceId(organizationId: string): string {
  const workspaces = Account.workspaces();
  const bySchema = workspaces.find(w => w.db_schema === organizationId);
  if (bySchema) {
    return bySchema.id;
  }
  const byId = workspaces.find(w => w.id === organizationId);
  if (byId) {
    return byId.id;
  }
  return Account.resolveFirstWorkspaceId() ?? '';
}
